export default {
  DESKTOP: 900,
  TABLET: 600,
  PHONE: 400,
};
